import { createFileRoute } from '@tanstack/react-router';
import { PagFor } from '@/features/pagfor/PagFor';

export const Route = createFileRoute('/a/pagfor/listagem')({
    component: PagFor,
});
